let landingPath

export const recordLanding = () => {
  if (typeof window === "undefined") return
  if (!landingPath) {
    try {
      landingPath = window.sessionStorage.getItem("zeitarc_landing_path") || window.location.pathname
      window.sessionStorage.setItem("zeitarc_landing_path", landingPath)
    } catch {
      landingPath = window.location.pathname
    }
  }
  return landingPath
}

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return
  const landing = recordLanding()
  if (window.gtag) {
    window.gtag("event", eventName, {
      ...params,
      landing_path: landing,
      page_path: window.location.pathname,
      site_locale: window.location.pathname.match(/^\/(de|es|tr)(\/|$)/)?.[1] || "en",
    })
  }
}
